var socialBtns = function () {
	function socialWindow (event) {
		var left = (screen.width - 570) / 2;
		var top = (screen.height - 570) / 2;
		var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
		event.preventDefault();
		window.open($(this).attr('href'), "NewWindow", params);
	}

	var init = function () {
		$socialButton = $('.js-socialBtns');

		$socialButton.click(socialWindow);
	};

	return {
		init: init
	};
}();

UL.register(socialBtns);
